module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "value": null,
      "filterable": ""
    },
    model: {
      value: (_vm.currentTaxonomy),
      callback: function($$v) {
        _vm.currentTaxonomy = $$v
      },
      expression: "currentTaxonomy"
    }
  }, _vm._l((_vm.taxonomyGroups), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item, index) {
      return _c('el-option', {
        key: (index + "-" + (item.value)),
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eec25fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/taxonomies/TaxonomySelect.vue
// module id = 3168
// module chunks = 3